// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ads-module{display:flex;flex-direction:column;gap:59px}@media(max-width: 591px){.ads-module{gap:24px}}`, "",{"version":3,"sources":["webpack://./src/matchScreen/redesign/styles/AdsModule/AdsModule.scss"],"names":[],"mappings":"AAEA,YACE,YAAA,CACA,qBAAA,CACA,QAAA,CAEA,yBALF,YAMI,QAAA,CAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
